import { Fragment } from "react"

import { define, prop } from "@/components/builder/utils"
import { useDnDBypassContext } from "@/components/builder/utils/bypass-context"

import BasePreview from "../../base"
import { useTCPAQuestion } from "../context"

function MidpathTCPAConsentPreview(props) {
  const tcpaquestion = useTCPAQuestion()
  const { data: { value: data } } = useDnDBypassContext()
  const { position } = data || {}
  if (!tcpaquestion) return null

  const { consentText } = tcpaquestion

  return <BasePreview {...props}>
    <div className="tcpa-consent-text">
      <label>
        <input type="hidden" id="leadid_tcpa_disclosure_${cfid}" />
        {consentText.replace('<position>', position)}
      </label>
    </div>
  </BasePreview>
}

export default define('tcpa-consent-text', MidpathTCPAConsentPreview, Fragment)
  .shared(prop.share('MidpathTCPAConsent', 'tcpa-consent-text'), { prefix: false })
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()
